"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useSizes;
exports.getPtg = getPtg;
var _react = _interopRequireDefault(require("react"));
function getPtg(str) {
  return Number(str.slice(0, -1)) / 100;
}
function isPtg(itemSize) {
  return typeof itemSize === 'string' && itemSize.endsWith('%');
}
/**
 * Save the size state.
 * Align the size into flex percentage base.
 */
function useSizes(items, containerSize) {
  var propSizes = items.map(function (item) {
    return item.size;
  });
  var itemsCount = items.length;
  var mergedContainerSize = containerSize || 0;
  var ptg2px = function ptg2px(ptg) {
    return ptg * mergedContainerSize;
  };
  // We do not need care the size state match the `items` length in `useState`.
  // It will calculate later.
  var _react$default$useSta = _react["default"].useState(function () {
      return items.map(function (item) {
        return item.defaultSize;
      });
    }),
    _react$default$useSta2 = _slicedToArray(_react$default$useSta, 2),
    innerSizes = _react$default$useSta2[0],
    setInnerSizes = _react$default$useSta2[1];
  var sizes = _react["default"].useMemo(function () {
    var _a;
    var mergedSizes = [];
    for (var i = 0; i < itemsCount; i += 1) {
      mergedSizes[i] = (_a = propSizes[i]) !== null && _a !== void 0 ? _a : innerSizes[i];
    }
    return mergedSizes;
  }, [itemsCount, innerSizes, propSizes]);
  // Post handle the size. Will do:
  // 1. Convert all the px into percentage if not empty.
  // 2. Get rest percentage for exist percentage.
  // 3. Fill the rest percentage into empty item.
  var postPercentSizes = _react["default"].useMemo(function () {
    var ptgList = [];
    var emptyCount = 0;
    // Fill default percentage
    for (var i = 0; i < itemsCount; i += 1) {
      var itemSize = sizes[i];
      if (isPtg(itemSize)) {
        ptgList[i] = getPtg(itemSize);
      } else if (itemSize || itemSize === 0) {
        var num = Number(itemSize);
        if (!Number.isNaN(num)) {
          ptgList[i] = num / mergedContainerSize;
        }
      } else {
        emptyCount += 1;
        ptgList[i] = undefined;
      }
    }
    var totalPtg = ptgList.reduce(function (acc, ptg) {
      return acc + (ptg || 0);
    }, 0);
    if (totalPtg > 1 || !emptyCount) {
      // If total percentage is larger than 1, we will scale it down.
      var scale = 1 / totalPtg;
      ptgList = ptgList.map(function (ptg) {
        return ptg === undefined ? 0 : ptg * scale;
      });
    } else {
      // If total percentage is smaller than 1, we will fill the rest.
      var avgRest = (1 - totalPtg) / emptyCount;
      ptgList = ptgList.map(function (ptg) {
        return ptg === undefined ? avgRest : ptg;
      });
    }
    return ptgList;
  }, [sizes, mergedContainerSize]);
  var postPxSizes = _react["default"].useMemo(function () {
    return postPercentSizes.map(ptg2px);
  }, [postPercentSizes, mergedContainerSize]);
  var postPercentMinSizes = _react["default"].useMemo(function () {
    return items.map(function (item) {
      if (isPtg(item.min)) {
        return getPtg(item.min);
      }
      return (item.min || 0) / mergedContainerSize;
    });
  }, [items, mergedContainerSize]);
  var postPercentMaxSizes = _react["default"].useMemo(function () {
    return items.map(function (item) {
      if (isPtg(item.max)) {
        return getPtg(item.max);
      }
      return (item.max || mergedContainerSize) / mergedContainerSize;
    });
  }, [items, mergedContainerSize]);
  // If ssr, we will use the size from developer config first.
  var panelSizes = _react["default"].useMemo(function () {
    return containerSize ? postPxSizes : sizes;
  }, [postPxSizes, containerSize]);
  return [panelSizes, postPxSizes, postPercentSizes, postPercentMinSizes, postPercentMaxSizes, setInnerSizes];
}